export function normalizedDataReceived(entities) {
  return { type: "NORM_DATA_RECEIVED", ...entities };
}
